import PDPPricingManager from './PDPPricingManager';

document.addEventListener( 'DOMContentLoaded', function() {
	if ( window?.QalaDynamicPricingMatrixCombinations === undefined ) {
		new PDPPricingManager();
	}
} );
